import SkeletonGroupedCardList from './skeletonGroupedCardList';

const TRANSACTION_CARD_ROWS = [1, 1, 2];

/** New to same matter, use as template, edit and go-to-detail. */
export const TRANSACTION_CARD_ACTION_COUNT = 4;

/** The date-grouped transaction shape shared by the dashboard and transaction views. */
const SkeletonTransactionList = ({ count = 4 }: { count?: number }) => (
  <SkeletonGroupedCardList
    rows={TRANSACTION_CARD_ROWS}
    count={count}
    actionCount={TRANSACTION_CARD_ACTION_COUNT}
  />
);

export default SkeletonTransactionList;
